<template>
  <div class="foot common-flex common-justify-between">
    <img class="logo" src="../assets/images/logohei.png" alt="" />
    <div class="common-flex">
      <div
        v-for="(item, index) in menu"
        :key="index"
        style="margin-left: 42px"
        @click="goPages(item)"
        class="common-hover common-flex common-align-center"
      >
        <img class="foot-img" :src="item.img" alt="" />
        <!-- <div :class="item.icon" style="color:#fff"></div> -->
        <div class="foot-font">{{ item.name }}</div>
      </div>
      <div
        class="common-flex common-align-center common-hover"
        style="
          margin-top: 18px;
          height: 24px;
          margin-left: 20px;
          border-left: 1px solid #808080;
          padding-right: 20px;
        "
      >
        <img
          style="height: 14px; margin-left: 20px"
          src="../assets/images/email.png"
          alt=""
        />
        <div style="font-size: 14px; color: #fff; margin-left: 10px">
          order@smartmtm.com
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  data() {
    return {
      menu: [
        // {
        //   name: "Facebook",
        //   img: require("../assets/images/facebook.png"),
        //   uri: "https://www.facebook.com/Steven-Tailoring-105815164584021",
        // },
        // {
        //   name: "Twitter",
        //   img: require("../assets/images/Twitter.png"),
        // },
        // {
        //   name: "Pinterest",
        //   img: require("../assets/images/pinterest.png"),
        // },
        {
          name: "Facebook",
          uri: "https://www.facebook.com/Steven-Tailoring-105815164584021",
          img: require("../assets/images/facebook.png"),
        },
        {
          name: "LinkedIn",
          uri: "https://www.linkedin.com/company/67926850/admin/",
          img: require("../assets/images/Linkedln.png"),
        },
        {
          name: "Instagram",
          uri: "https://www.instagram.com/smartmtm_official/",
          img: require("../assets/images/ins.png"),
        },
      ],
    };
  },
  methods: {
    goPages(e) {
      window.open(e.uri);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.foot {
  height: 60px;
  background: #000000;
  overflow: hidden;
  width: 100%;
  .logo {
    height: 60px;
    margin: 0 0 0 20px;
  }
  .foot-img {
    height: 14px;
    margin-right: 5px;
  }
  .foot-font {
    font-size: 14px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue